import { mapToImpactResearchTopic } from "~/mappers";
import { useImpactTrackingV2Service } from "~/composables/useImpactTrackingV2Service";
import { FrontiersImpactActionNames } from "~/types/global/enums";
import { isRouteCacheEnabled } from "~/utils/routeCache";

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) return;
  if (!to.name?.toString().includes("research-topics-rtId-rtSlug")) return;
  if (isRouteCacheEnabled()) return;

  const event = useRequestEvent();

  if (event) {
    const {
      currentResearchTopic: { id, journals }
    } = useMain();
    const { loggedUser } = useAuthStore();
    const { sendTracking } = useImpactTrackingV2Service(event.node.req);

    const impactRt = mapToImpactResearchTopic(id, journals);

    sendTracking(
      FrontiersImpactActionNames.ResearchTopicView,
      impactRt,
      loggedUser?.id
    );
  }
});
